import { normalizeTravelerType } from '@travel-planner/shared/pricing';
import { useMemo } from 'react';
import { trpc } from '@/shared/api/trpc';

const EMPTY: ReadonlySet<string> = new Set();

const useTravellerTypeIds = (
  kind: ReturnType<typeof normalizeTravelerType>
): ReadonlySet<string> => {
  const query = trpc.productPricing.listTravellerTypes.useQuery(undefined, {
    staleTime: 10 * 60 * 1000,
  });
  return useMemo(() => {
    const rows = query.data?.data ?? [];
    const ids = rows
      .filter((row) => normalizeTravelerType(row.title) === kind)
      .map((row) => row.id);
    return ids.length > 0 ? new Set(ids) : EMPTY;
  }, [kind, query.data]);
};

/**
 * The organization's adult traveller types — what a per-person product price
 * is shown for in product lists (XT-789). `productPricing.listTravellerTypes`
 * needs only `products:read`, which anyone seeing a product list already has.
 * Empty until it loads, which falls back to the first priced row.
 */
export const useAdultTravellerTypeIds = (): ReadonlySet<string> =>
  useTravellerTypeIds('adult');

/** The organization's child traveller types — a per-person Child rate. */
export const useChildTravellerTypeIds = (): ReadonlySet<string> =>
  useTravellerTypeIds('child');
